import { useRef, useCallback, useEffect } from 'react';

// Resuelve un elemento por su data-testid (las paginas ya los tienen).
export function resolveTarget(testId) {
  return document.querySelector('[data-testid="' + testId + '"]');
}

// useHighlight(): devuelve { highlight, clear }.
//  highlight(testId, ms=2500): resalta el elemento con el anillo 'help-ring'.
//    - hace scroll SOLO si no esta visible (evita saltos molestos en hover).
//    - ms>0: auto-retira el anillo tras ms (uso en click). ms=0: persiste hasta clear (uso en hover).
//    - no-op silencioso si el target no esta montado.
//  clear(): retira el anillo actual y cancela el timer.
export function useHighlight() {
  const timer = useRef(null);
  const last = useRef(null);
  const clear = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    if (last.current) last.current.classList.remove('help-ring');
    timer.current = null;
    last.current = null;
  }, []);
  useEffect(() => clear, [clear]); // limpia al desmontar
  const highlight = useCallback((testId, ms = 2500) => {
    clear();
    const el = resolveTarget(testId);
    if (!el) return;
    // Solo el uso "click" (ms>0) hace scroll; el hover (ms=0) NUNCA mueve el scroll
    // (movia el viewport del editor y perdia la linea de hojas). 'nearest' minimiza el salto.
    if (ms > 0) {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const visible = r.top >= 0 && r.bottom <= vh;
      if (!visible) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    void el.offsetWidth; // reflow: reinicia la animacion si es el mismo elemento
    el.classList.add('help-ring');
    last.current = el;
    if (ms > 0) {
      timer.current = setTimeout(() => {
        el.classList.remove('help-ring');
        timer.current = null;
        last.current = null;
      }, ms);
    }
  }, [clear]);
  return { highlight, clear };
}
